export const listVariousDocumentAdminService = (fetch) => async ({ filters }) => {
  try {
    const searchParams = new URLSearchParams(filters).toString()
    const response = await fetch({ url: `/api/v1/documentos-admin-varios?${searchParams}` })
    return response
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message)
  }
}
